import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AgGridAngular } from 'ag-grid-angular';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ApiService } from 'src/app/api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-addsms-templates',
  templateUrl: './addsms-templates.component.html',
  styleUrls: ['./addsms-templates.component.css']
})
export class AddsmsTemplatesComponent implements OnInit {
  @ViewChild('agGrid',{static:false}) agGrid: AgGridAngular;
  SMScolumnDefs = [
    {headerName: 'ID', field: '_id', width: 250, checkboxSelection: true,headerCheckboxSelection: true,sortable: true, filter: true},
    {headerName: 'Template', field: 'template', resizable: true, sortable: true, filter: true},
    {headerName: 'Bank ID', field: 'bank_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Product ID', field: 'product_id', resizable: true, sortable: true, filter: true},
    {headerName: 'portfolio ID', field: 'portfolio_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Bucket ID', field: 'bucket_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Created At', field: 'createdAt', resizable: true, sortable: true, filter: true},
    {headerName: 'Update At', field: 'updatedAt', resizable: true, sortable: true, filter: true},
    {headerName: 'Status', field: 'status', sortable: true, filter: true},
    {headerName: 'Options', width: 120,cellRenderer: function(params) {
      return "";
    }},
  ];
  templateFrom: UntypedFormGroup;
  BankList: any;
  ProductList: any;
  PortfolioList: any;
  BucketList: any;
  SMSTemplateList = [];
  addmode: boolean;
  editmode: boolean;

  constructor(private formBuilder:UntypedFormBuilder, @Inject(SESSION_STORAGE) private storage: StorageService, private _api:ApiService) {
    this.templateFrom = this.formBuilder.group({
      id:[''],
      template:['',Validators.required],
      bank_id:['',Validators.required],
      portfolio_id:['',Validators.required],
      product_id:['',Validators.required],
      bucket_id:['',Validators.required],
      status:['',Validators.required],
    })
  }

  ngOnInit(): void {
    this.addmode = true;
    this.editmode = false;
    let a = {
      client_id : this.getFromLocal("Client_ID")
    }
    this._api.fetch_bank_list_by_client_id(a).subscribe(data=>{
      if (data['Code']==200) {
        this.BankList = data['Data'];
      } else {
        this.BankList = [];
      }
    });
    this._api.product_type_list(a).subscribe(data=>{
      if (data['Code']==200) {
        this.ProductList = data['Data'];
      } else {
        this.ProductList = [];
      }
    });
    this._api.portfolio_type_list(a).subscribe(data=>{
      if (data['Code']==200) {
        this.PortfolioList = data['Data'];
      } else {
        this.PortfolioList = [];
      }
    });
    this._api.bucket_type_list().subscribe(data=>{
      if (data['Code']==200) {
        this.BucketList = data['Data'];
      } else {
        this.BucketList = [];
      }
    });
  }

  getFromLocal(key): any {
    return this.storage.get(key);
  }

  addSMS(){
    if (this.templateFrom.valid) {
      Swal.fire({
        //title: 'Cannot ADD!',
        text: 'New SMS Template created Successfully',
        icon: 'success',
        showCancelButton: false,
        timer: 1800
      }).then(()=>{
        
      });
    } else {
      Swal.fire({
        title: 'Cannot ADD!',
        text: 'Please Fill all Details',
        icon: 'warning',
        showCancelButton: false,
        timer: 1800
      }).then(()=>{
        
      });
    }
  }
  editSMS(){
    this.addmode = false;
    this.editmode = true;
  }
  cancelSMS(){
    this.addmode = true;
    this.editmode = false;
  }
  updateSMS(){
    if (this.templateFrom.valid) {
      Swal.fire({
        //title: 'Cannot UPDATE !',
        text: ' SMS Template updated Successfully',
        icon: 'success',
        showCancelButton: false,
        timer: 1800
      }).then(()=>{
        
      });
    } else {
      Swal.fire({
        title: 'Cannot UPDATE !',
        text: 'Please Fill all Details',
        icon: 'warning',
        showCancelButton: false,
        timer: 1800
      }).then(()=>{
        
      });
    }
  }
  deleteSMS(){
    
  }
  onPageReload(){

  }

}
